import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { ILogoConfig } from '@nibtravel/shared/ui/components/logo';
import { Observable } from 'rxjs';

/**
 * Presentational component that represents the header
 *
 * @export
 * @class HeaderComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'nibtravel-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @HostBinding('class') classes = 'header';

  /** The header title */
  @Input() title!: Observable<string>;

  /** The logo configuration to be used within the header */
  @Input() logoConfig!: ILogoConfig;
}
